
import { Box, Button, Divider, Paper, Stack, TextField, Tooltip, Drawer, Typography, Autocomplete, Modal, Checkbox, IconButton } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import "../../../Pharmacy/PharmacyPurchase/PharmaPurchase.css"
import { ImagePaths } from '../../../../Utility/ImagePaths';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { CommonGridToolBarWithFilterText, CommonGridToolBarWithFilterTextCustom } from '../../../../Components/Common Components/CommonComponents';
import { formatDate, CheckAccessFunc } from "../../../../Components/CommonFunctions/CommonFunctions";
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { Colors } from '../../../../Styles/Colors';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import ColorLensIcon from '@mui/icons-material/ColorLens';

let selectedStatus = ["Active", "Inactive"]

let RoleData = null;
let userAccess = null;
class ContainerMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      containerMasterData: [],
      containerName: "",
      page: 0,
      pageSize: 10,
      rowCount: 0,
      selected_Status: "",
      openPopUp: false,
      isFromEdit: false,
      containerCode: null,
      containerName: "",
      // order : "",
      shortName: "",
      filterDeptStatus: true,
      deptStatus: true,
      color:  null,
      comments: "",
      selectedRow: {},
      selectedId: "",
      postLoad :false,
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  componentDidMount() {
    RoleData = JSON.parse(localGetItem("loggedInUserInfo"));
    userAccess = CheckAccessFunc("Laboratory", "Settings", "Lab Masters", "Container Master", "SubTab")
    this.getContainerMasterData()
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }
  handleValidation = () => {
    if (!this.state.containerName) {
        this.errorMessage("Enter Container Name")
        this.setState({postLoad : false})
    } else if (this.state.filterDeptStatus === false && !this.state.comments) {
        this.errorMessage("Enter Inactive Reason")
        this.setState({postLoad : false})
    } else {
      this.postContainerMasterData()
    }
  }

  postContainerMasterData = () => {
    try {
      let status = this.state.selected_Status ? true : false
      this.LoaderFunction(true);
      let data = {
        "container_name": this.state.containerName ? CommonValidation.removeSpace(this.state.containerName) :"",
        "is_active": this.state.filterDeptStatus ? this.state.filterDeptStatus : status,
        "container_color": this.state.color,
        "container_short_name": this.state.shortName ? CommonValidation.removeSpace(this.state.shortName) :"",
        "container_code": this.state.containerCode ? this.state.containerCode : null,
        "inactive_reason": this.state.comments? CommonValidation.removeSpace(this.state.comments) :"",
        "id": this.state.selectedId,

      }
      RestAPIService.create(data, Serviceurls.GET_LAB_CONTAINER_MASTER).
        then((response) => {
          if (response.data.status === "success") {
            this.successMessage(response.data.message)
            this.LoaderFunction(false);
            this.setState({ openPopUp: false, isFromEdit: false, selectedId: null, container_code: "", postLoad :false })
            this.handleClear()
            this.getContainerMasterData()
          }
          else {
            this.setState({postLoad : false})
            this.LoaderFunction(false);
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.setState({postLoad : false})
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
          this.LoaderFunction(false);
        })
    }
    catch (e) {
      this.setState({postLoad : false})
      this.errorMessage(e.message)
    }
  }


  getContainerMasterData = () => {
    try {
      let status = this.state.selected_Status === "Active" ? true : this.state.selected_Status === "Inactive" ? false : ""
      this.LoaderFunction(true);
      RestAPIService.getAll(Serviceurls.GET_LAB_CONTAINER_MASTER + `?container_name=${this.state.containerName}&is_active=${status}`).
        then((response) => {
          if (response.data.status === "success") {
            this.LoaderFunction(false);
            this.setState({
              containerMasterData: response?.data?.data ? response?.data?.data :[],
            })
          }
          else {
            this.LoaderFunction(false);
            this.errorMessage(response?.data?.message)
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
          this.LoaderFunction(false);
        })
    }
    catch (e) {
      this.errorMessage(e?.message)
    }
  }
  closeFilter = () => {
    this.setState({ FilterOpen: false })
  }
  handleClear = () => {
    this.setState({
      containerName: "",
      selected_Status: "",
      filterDeptStatus: true,
      deptStatus: "",
      color: "",
      shortName: "",
      comments: "",
    })
  }

  renderFilterScreen = () => {
    const { t } = this.props;
    let states = this.state;
    return (
      <Box component={"div"} className='eMed_rts_filter_container'>
        <Box component={"div"} className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>{t('Filter')}</Typography>
          <Button emed_tid="vnd_close" onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
          </Button>
        </Box>
        <Box className='eMed_rts_middle'>
          <Box className='eMed_rts_dropdown'>
            <TextField
              label={t("Search Container")}
              sx={{ width: "20vw" }}
              size="small"
              autoComplete="off"
              value={states.containerName ? states.containerName : ""}
              inputProps={{ emed_tid: "container Name", maxLength: 100 }}
              onChange={(e) => {
                this.setState({
                  containerName: e.target.value.trimStart()
                })
              }}
            />
          </Box>
          <Box className='eMed_rts_dropdown'>
            <Autocomplete
              size='small'
              sx={{ width: "20vw" }}
              disableClearable
              options={selectedStatus}
              getOptionLabel={(option) => (option)}
              value={this.state.selected_Status}
              onChange={(event, newValue) => {
                this.setState({ selected_Status: newValue })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputProps={{ ...params.inputProps, 'emed_tid': 'concession_Type_TestID', }}
                  label={t('Select Status')}
                  autoComplete='off'
                />
              )}
            />
          </Box>
        </Box>
        <Stack spacing={2} direction="row" className='eMed_rts_btn' alignItems="center" justifyContent="center">
          <Button variant='outlined' size="small" emed_tid="fil_clear"
            onClick={() => {
              this.setState({
                containerName: "",
                selected_Status: ''
              }, () => this.getContainerMasterData())
            }}
            id="eMed_Config_btn">{t("Clear")}</Button>
          <Button variant='contained' size="small" emed_tid="fil_search"
            onClick={() => {
              this.getContainerMasterData()
              this.setState({ FilterOpen: false })
            }}
            id="eMed_Config_btn">{t("Search")}</Button>
        </Stack>
      </Box>
    )
  }
  handleEdit = (data) => {
    this.setState({
      isFromEdit: true,
      openPopUp: true,
      containerCode: data?.container_code ? data?.container_code :null,
      containerName: data?.container_name ? data?.container_name :"",
      shortName: data?.container_short_name ? data?.container_short_name :"",
      selectedId: data?.id,
      color: data?.container_color ? data?.container_color : null,
      filterDeptStatus: data?.is_active,
      comments: data?.inactive_reason ? data?.inactive_reason :""

    })

  }
  renderTextField = (value, statekey, Label, required, width, disable = false) => {
    const { t } = this.props;
    let states = this.state
    return (
      <TextField
        sx={{ width: width ? width : "12vw", marginX: '0.65vw', marginTop: "1vw" }}
        size="small"
        disabled={disable}
        inputProps={{ maxLength: 100 }}
        autoComplete="off"
        label={t(Label)}
        required={required}
        value={value}
        onChange={(e) => {
          let value = e.target.value
            states[statekey] = value.trimStart()
            this.setState({ states })
        }}
      />
    )
  }
  handleChangeColor = (event) => {
    this.setState({
      color: event.target.value
    })
  }
  addNewContainerPopup = () => {
    let states = this.state
    return (
      <div>
        <Modal open={this.state.openPopUp}>
          <Box component={"div"} className='eMed_Doc_Notes_Counsellor_Pop_Up' style={{ padding: "1vw", width: "42vw", height: "66vh", maxHeight: "100%", display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <Box>
              <Box component={'div'} p={'0.5vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{states.isFromEdit ? "Edit Container" : "Add Container"}</Typography>
                <Button className='Common_Btn_Min_Width' onClick={() => this.setState({ openPopUp: false, selectedId: null, containerCode: "", isFromEdit: false }, () => { this.handleClear() })} >
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                </Button>
              </Box>
              <hr />
              <Box component={'div'} style={{ display: "flex", flexDirection: "row" }}>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                  <Box  >
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                      {this.state.isFromEdit ?
                        this.renderTextField(this.state.containerCode, "containerCode", "Container Code", true, "12vw", true)
                        : null}
                      {this.renderTextField(this.state.containerName, "containerName", "Container Name", true, !this.state.isFromEdit ? "18.5vw" :"12vw", false)}
                      {this.renderTextField(this.state.shortName, "shortName", "Short Name", false, !this.state.isFromEdit ? "18.5vw" :"12vw", false)}
                    </div>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Box component={'div'} style={{ display: "flex", flexDirection: "column" }}>
                  <Box sx={{ marginLeft: "1vh", marginTop: "2vh" }}>
                    <Typography>{"Select Container Color"}</Typography>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "row", alignItems: 'flex-start', justifyContent: "flex-start", marginLeft: '0.8vw', marginTop: '0.3vw' }}>
                    <Button size='small' component="label" variant='outlined' startIcon={<ColorLensIcon />}><input style={{ width: '0', height: '0', marginLeft: '0vw' }} hidden className="favouriteColor" type="color" name="favourite Color" value={this.state.color ? this.state.color : null} onChange={(event) => { this.handleChangeColor(event) }}></input>Choose Color</Button>
                    {this.state.color ? <div className="emed_ColorShowgrid" type="color" name="favourite Color" style={{ backgroundColor: this.state.color ? this.state.color : "white", width: "2vw", height: "1.5vw", marginLeft: "1vw", marginTop:"0.2vh" }} > </div> : <div style={{ width: "2vw", height: "1.5vw", marginLeft: "1vw", marginTop: "0.2vw" }} >N/A</div>}
                  </Box>
                  <Box component={'div'} style={{ display: "flex", flexDirection: "column" }}>
                    <Box sx={{ marginLeft: "1vh", marginTop: "2vh" }}>
                      <Typography>{"status"}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                      <Checkbox
                        disabled ={!this.state.isFromEdit}
                        checked={this.state.filterDeptStatus}
                        onChange={(e) => { this.setState({ filterDeptStatus: e.target.checked ,comments :""}) }}
                      />
                      <Typography>{"Active"}</Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
              {this.state.filterDeptStatus === false ?
                <Box>
                  <Box sx={{ marginLeft: "1vh", marginTop: "1vh" }}>
                    <Typography>{"Inactive Comments"}</Typography>
                  </Box>
                  <Box sx={{ marginLeft: "1vh", marginTop: "1vh" }}>
                    <div>
                      <TextField
                        size='small'
                        label={("Reason *")}
                        disabled ={!this.state.isFromEdit}
                        style={{ marginTop: "0.5vw", width: "38.6vw" }}
                        multiline={true}
                        inputProps={{ maxLength: 250 }}
                        rows={3}
                        variant="outlined"
                        value={this.state.comments}
                        onChange={(event) => {
                          let value = event.target.value
                          if (value?.length <= 250) {
                            this.setState({ comments: value })
                          } else {
                            this.errorMessage('Allowed only 250 characters')
                          }
                        }}
                      />
                    </div>
                  </Box>
                </Box>
                : null
              }
            </Box>
            <Box>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-end", marginRight: "2vw", marginTop: "1vw" }}>
                <Button
                  sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
                  variant='outlined'
                  onClick={() => { this.handleClear() }}
                >Clear</Button>
                <Button
                  sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                  disabled={this.state.postLoad}
                  variant='contained'
                  onClick={() => { 
                    this.setState({postLoad : true},()=>{ this.handleValidation()})
                    }}
                >{states.isFromEdit ? "Update" : "Add"}</Button>
              </div>
            </Box>
          </Box>
        </Modal>
      </div>
    )
  }
  gridToolBar = () => {

    var ExportData = []
    this.state.containerMasterData?.length > 0 && this.state.containerMasterData?.map((item) => {

      return (
        ExportData?.push({
          "SI.No": item?.sno, "Container Code": item?.container_code, "Container Name": item?.container_name, "Container Short Name": item?.container_short_name, "Status": item?.is_active === true ? "Active" : item?.is_active === false ? "InActive" : "",
        })
      )
    }
    )
    return (
      <Box>
        <CommonGridToolBarWithFilterTextCustom data={ExportData} title={"Container Master"} filename={"Container Master"} />
      </Box>
    )
  }

  renderTable = () => {
    this.state.containerMasterData?.forEach((element, index) => element.sno = index + 1)

    const { t } = this.props
    const columns = [
      {
        field: "sno", flex: 0.03, headerName: t("SNo"), headerAlign: "center", align: "center",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.sno ? params?.row?.sno : "-"}</Box>)
      },
      {
        field: "container_code", flex: 0.166, headerName: t("Container Code"), headerAlign: "center", align: "center",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.container_code ? params?.row?.container_code : "-"}</Box>)
      },
      {
        field: "container_name", flex: 0.166, headerName: t("Container Name"), headerAlign: "left", align: "left",
        renderCell: ({ row }) => (<div>{row?.container_name?.length > 23 ?
          <Tooltip placement="top" title={row?.container_name} arrow><div>{row?.container_name.slice(0, 22) + "..."}</div></Tooltip>
          : row?.container_name ? row?.container_name : "-"}</div>)
      },
      {
        field: "container_short_name", flex: 0.186, headerName: t("Short Name"), headerAlign: "left", align: "left",
        renderCell: (params) => (<div>{params?.row?.container_short_name?.length > 10 ?
          <Tooltip placement="top" title={params?.row?.container_short_name} arrow><div>{params?.row?.container_short_name.slice(0, 15) + "..."}</div></Tooltip>
          : params?.row?.container_short_name ? params?.row?.container_short_name : "-"}</div>)
      },
      {
        field: 'color', headerName: t("Color"), flex: 0.15, headerAlign: "left", align: "left", renderCell: (params) => {
         return  params?.row?.container_color ? <div className="emed_ColorShowgrid" type="color" name="favourite Color" style={{ backgroundColor: params?.row?.container_color ? params?.row?.container_color : "N/A", width: "2vw", height: "1.5vw" ,marginLeft :"-0.2vw"}} > </div> : "N/A"
        }
      },
      {
        field: "is_active", flex: 0.166, headerName: t("Status"), headerAlign: "left", align: "left",
        renderCell: (params) => {
          return (
            <Tooltip placement="top" title={params?.row?.inactive_reason} arrow><div>{params?.row?.is_active ? "Active" : "Inactive"}</div></Tooltip>  
          )
        }
      },
      {
        field: "action", flex: 0.134, headerName: t("Action"), headerAlign: "center", align: "center", sortable: false,
        renderCell: (params) => <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
          {userAccess?.editAccess ? <Tooltip title={t("Edit")} placement="top" onClick={() => { this.handleEdit(params.row) }} arrow>
            <Button emed_tid="vnd_edit" className='eMed_usrconf_btn'>
              <img src={ImagePaths.Edit.default} alt="print" className='eMed_action_img' />
            </Button>
          </Tooltip> : null}
        </Box>
      }
    ]
    return (
      <Box component={"div"} className='eMed_Purcahse_Table_Container' style={{ backgroundColor: Colors.Background }}>
        <Stack component={"div"}>
          <Paper className='eMed_Purchase_Table_Wrapper' >
            <DataGrid
              rows={this.state.containerMasterData}
              columns={columns}
              getRowId={(row) => row['sno']}
              page={this.state.page}
              pageSize={this.state.pageSize}
              hideFooterSelectedRowCount
              localeText={{
                toolbarColumns: "",
                toolbarDensity: "",
                toolbarExport: "",
                toolbarFilters: "",
                toolbarExportPrint: ""
              }}
              headerHeight={40}
              components={{
                Toolbar: this.gridToolBar,
                NoRowsOverlay: () => (
                  <Stack className='eMed_conf_nodata'>
                    {t("NoRecordsFound")}
                  </Stack>
                )
              }}
              loading={this.state.isLoader}
              rowCount={this.state.containerMasterData?.length}
              onPageChange={(newPage) => { this.setState({ page: newPage }) }}
              onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
              rowsPerPageOptions={[10, 20, 30]}
              pagination
              disableSelectionOnClick
            />
          </Paper>
        </Stack>
      </Box>
    )
  }
  render() {
    const { t } = this.props;
    return (
      <div>
        <div className='eMed_Purchase_Table_top' style={{ backgroundColor: Colors.Background }}>
          {userAccess?.editAccess ? <><Button emed_tid="add_vnd" className='eMed_Filter_Btns' variant='contained' size='small' onClick={() => { this.setState({ openPopUp: true }) }}>{`Add New Container`}</Button>
          <Divider orientation='vertical' /></> : null}
          <Tooltip title="Filter" placement='top' arrow>
            <Button emed_tid="vnd_filter" className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
              <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
            </Button>
          </Tooltip>

        </div>
        {this.renderTable()}
        {this.addNewContainerPopup()}
        <Drawer
          anchor={'right'}
          open={this.state.FilterOpen}
          ModalProps={{ onBackdropClick: this.closeFilter }}
        >
          {this.renderFilterScreen()}
        </Drawer>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}

      </div>
    )
  }
}
export default withTranslation()(ContainerMaster)






